import produce from "immer";

import { USERS_PUBLIC_WATCH_ON } from "../actions/types";

const initialState = null;

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case USERS_PUBLIC_WATCH_ON:
        draft = action.payload;
        return draft;
    }
  });
};
